__turbopack_context__.v({
  "offer-label": "ProductOfferLabel-module-scss-module__X4YswW__offer-label",
  "offer-label__item": "ProductOfferLabel-module-scss-module__X4YswW__offer-label__item",
  "offer-label__toggle": "ProductOfferLabel-module-scss-module__X4YswW__offer-label__toggle",
});
